import React from 'react';
import { motion } from 'framer-motion';
import { PlayIcon } from 'lucide-react';
export function VSL() {
  return <section className="py-24 bg-primary relative overflow-hidden" data-id="element-164">
      {/* Background Glow */}
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[900px] h-[900px] rounded-full pointer-events-none" style={{
      background: 'radial-gradient(ellipse at center, rgba(255,107,0,0.12) 0%, transparent 70%)'
    }} data-id="element-165" />

      <div className="absolute inset-0 bg-grid-pattern opacity-10 pointer-events-none" data-id="element-166" />

      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-167">
        <div className="text-center mb-12" data-id="element-168">
          <motion.span initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} className="text-accent text-sm font-bold tracking-widest uppercase mb-4 block" data-id="element-169">
            MIRÁ EL VIDEO
          </motion.span>
          <motion.h2 initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.1
        }} className="text-4xl md:text-5xl font-heading font-bold text-white mb-4" data-id="element-170">
            Descubrí cómo funciona el{' '}
            <span className="text-gradient" data-id="element-171">sistema</span>
          </motion.h2>
          <motion.p initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: 0.2
        }} className="text-text-secondary text-lg max-w-2xl mx-auto" data-id="element-172">
            En menos de 5 minutos vas a entender exactamente cómo puedo escalar
            tu facturación.
          </motion.p>
        </div>

        <motion.div initial={{
        opacity: 0,
        y: 40,
        scale: 0.97
      }} whileInView={{
        opacity: 1,
        y: 0,
        scale: 1
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="relative rounded-2xl overflow-hidden border border-accent/30 shadow-2xl" style={{
        boxShadow: '0 0 60px rgba(255,107,0,0.25)'
      }} data-id="element-173">
          {/* Video placeholder — replace src with actual video URL */}
          <div className="relative aspect-video bg-[#111] flex items-center justify-center group cursor-pointer" data-id="element-174">
            {/* Replace this div with an <iframe> or <video> tag when ready */}
            <div className="absolute inset-0 bg-gradient-to-br from-[#1a0f00] to-[#0a0a0a]" data-id="element-175" />
            <div className="absolute inset-0 bg-grid-pattern opacity-30" data-id="element-176" />

            <div className="relative z-10 flex flex-col items-center text-center px-6" data-id="element-177">
              <div className="w-24 h-24 rounded-full bg-accent flex items-center justify-center mb-6 transition-transform duration-300 group-hover:scale-110" style={{
              boxShadow: '0 0 40px rgba(255,107,0,0.7)'
            }} data-id="element-178">
                <PlayIcon className="w-10 h-10 text-white ml-1" fill="white" strokeWidth={0} data-id="element-179" />
              </div>
              <p className="text-white font-bold text-xl mb-2" data-id="element-180">
                Reproducir video
              </p>
              <p className="text-text-secondary text-sm" data-id="element-181">
                [ Espacio reservado para el VSL ]
              </p>
            </div>
          </div>
        </motion.div>

        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        delay: 0.4
      }} className="text-center mt-10" data-id="element-182">
          <a href="#agendar" className="inline-flex items-center justify-center px-8 py-4 text-base font-bold rounded-xl text-white bg-accent glow-button" data-id="element-183">
            Quiero escalar mi negocio
          </a>
        </motion.div>
      </div>
    </section>;
}